import React from 'react';

const Footer: React.FC = () => {
  return (
    <>
      <style>{`
        /* Custom footer animations & overrides */
        .footer-link {
          transition: color 0.2s ease, padding-left 0.2s ease;
        }
        .footer-link:hover {
          color: #F59E0B; /* amber-500 */
          padding-left: 5px;
        }

        .whatsapp-footer-link {
          display: inline-flex;
          align-items: center;
          gap: 0.5rem;
          background: rgba(37, 211, 102, 0.12);
          padding: 0.5rem 1rem;
          border-radius: 40px;
          margin-top: 0.5rem;
          border: 1px solid #25d366;
          transition: all 0.2s ease;
          color: #1f2937;
          text-decoration: none;
        }
        .whatsapp-footer-link:hover {
          background: rgba(37, 211, 102, 0.25);
          transform: translateX(3px);
        }

        .footer-bottom {
          text-align: center;
          padding-top: 2.5rem;
          margin-top: 2rem;
          border-top: 1px solid rgba(245, 158, 11, 0.2);
          font-size: 0.9rem;
          color: #6b7280;
        }
        .footer-bottom span {
          color: #F59E0B;
        }

        /* Perfect alignment for footer grid */
        .footer-grid {
          display: grid;
          grid-template-columns: 2fr 1fr 1.5fr;
          gap: 2rem;
          align-items: start;
        }

        /* Responsive grid adjustments */
        @media (max-width: 1000px) {
          .footer-grid {
            grid-template-columns: repeat(2, 1fr) !important;
          }
        }
        @media (max-width: 600px) {
          .footer-grid {
            grid-template-columns: 1fr !important;
          }
        }

        /* Ensure all sections align properly */
        .footer-section {
          display: flex;
          flex-direction: column;
          height: 100%;
        }

        .contact-items {
          display: flex;
          flex-direction: column;
          gap: 0.75rem;
        }

        .contact-item {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          color: #4b5563;
        }

        .contact-item a {
          color: #4b5563;
          text-decoration: none;
          transition: color 0.2s ease;
        }

        .contact-item a:hover {
          color: #F59E0B;
        }

        .icon {
          color: #14b8a6;
          width: 1.25rem;
          display: inline-flex;
          justify-content: center;
        }

        /* Quick links list styling */
        .quick-links {
          list-style: none;
          padding: 0;
          margin: 0;
        }

        .quick-links li {
          margin-bottom: 0.5rem;
        }

        /* Email list styling - UPDATED for left alignment */
        .email-list {
          display: flex;
          flex-direction: column;
          gap: 0.25rem;
          text-align: left;
        }

        .email-list a {
          text-align: left;
          display: block;
        }

        /* Updated contact item for email to align properly */
        .contact-item.email-contact {
          align-items: flex-start;
        }

        .email-icon {
          margin-top: 4px;
          color: #14b8a6;
          width: 1.25rem;
          display: inline-flex;
          justify-content: center;
          flex-shrink: 0;
        }
      `}</style>

      <footer className="bg-white/70 backdrop-blur-md border-t border-amber-500/20 py-12 px-4 md:px-8 mt-16">
        <div className="max-w-7xl mx-auto">
          <div className="footer-grid">
            {/* Logo & Description - Section 1 */}
            <div className="footer-section">
              <h3 className="text-2xl md:text-3xl font-bold text-amber-500 mb-4">
                SAJ ENTERPRISES
              </h3>
              <p className="text-gray-600 text-sm md:text-base leading-relaxed">
                Industrial sales, service & spares. Trusted partner for Pune industries.
              </p>
            </div>

            {/* Quick Links - Section 2 */}
            <div className="footer-section">
              <h4 className="text-teal-500 font-semibold text-lg mb-4">Quick links</h4>
              <ul className="quick-links">
                {['Home', 'About', 'Products', 'Gallery', 'Contact'].map((item) => (
                  <li key={item}>
                    <a
                      href={`#${item.toLowerCase()}`}
                      className="footer-link text-gray-600 inline-block"
                    >
                      {item}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact Info - Section 3 */}
            <div className="footer-section">
              <h4 className="text-teal-500 font-semibold text-lg mb-4 text-left">Contact</h4>
              <div className="contact-items">
                <div className="contact-item">
                  <i className="fas fa-phone icon"></i>
                  <a href="tel:9359663830">9359663830</a>
                </div>
                
                <div className="contact-item">
                  <i className="fas fa-phone icon"></i>
                  <a href="tel:8888551919">8888551919</a>
                </div>
               
                {/* Updated Email section with left-aligned emails */}
                <div className="contact-item email-contact">
                  <i className="fas fa-envelope email-icon"></i>
                  <div className="email-list">
                    <a href="mailto:rahul@sajenterprises.com" className="hover:text-amber-500 transition-colors">
                      rahul@sajenterprises.com
                    </a>
                    <a href="mailto:parimal@sajenterprises.com" className="hover:text-amber-500 transition-colors">
                      parimal@sajenterprises.com
                    </a>
                  </div>
                </div>

                {/* WhatsApp Button */}
                <div className="mt-2">
                  <a
                    href="https://wa.me/919359663830"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="whatsapp-footer-link"
                  >
                    <i className="fab fa-whatsapp text-[#25d366]"></i>
                    <span>Chat on WhatsApp</span>
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Bar */}
          <div className="footer-bottom">
            © 2026 SAJ ENTERPRISES. All rights reserved. | Design:{' '}
            <span>ARRCTECHIE</span>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;